import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LOGO_URL } from "../lib/config";
import Footer from "./Footer";

export default function LegalLayout({ title, subtitle, lastUpdate, children }) {
  return (
    <div className="min-h-screen bg-fp-bg text-white" data-testid="legal-page">
      {/* Header */}
      <header className="border-b border-white/10 bg-fp-surface/40 backdrop-blur-xl sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-5 md:px-8 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <img src={LOGO_URL} alt="" className="w-10 h-10 group-hover:rotate-[-6deg] transition-transform" />
            <div>
              <div className="font-heading font-black silver-gradient text-sm">FANTA PARTENOPE</div>
              <div className="text-[10px] tracking-[0.3em] uppercase text-fp-cyan">ASD · Napoli</div>
            </div>
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-fp-cyan text-sm">
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </header>

      <section className="relative py-16 md:py-24 px-5 md:px-8 overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-20" />
        <div className="absolute inset-0 radial-glow opacity-40" />
        <div className="relative max-w-4xl mx-auto">
          <div className="text-xs tracking-[0.4em] uppercase text-fp-cyan font-heading font-semibold">
            {subtitle}
          </div>
          <h1 className="mt-3 font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tight silver-gradient">
            {title}
          </h1>
          {lastUpdate && (
            <div className="mt-4 text-xs text-white/40">Ultimo aggiornamento: {lastUpdate}</div>
          )}
          <div className="mt-10 legal-content text-white/75 leading-relaxed">{children}</div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
